import { combineReducers, createStore, Store, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { CommonStore } from 'sos-common/js/commonTypes/commonStore.types';
import { formModelStore } from './Reducers';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';

type getStoreCallback<T extends CommonStore> = (store: T) => void;

const initCommonStore = {
  globals: {
    shouldShowDelete: false,
  } as any,
};

let globalStore: CommonStore = createStore(
  combineReducers({
    globals: (state, action) => {
      // Create a dummy store.
      // console.log(action);
      return state || {};
    },
  }),
  initCommonStore
);

const callbacks: Array<getStoreCallback<any>> = [];

export function registerStore<T extends CommonStore>(store: T) {
  globalStore = store;
  callbacks.forEach((cb) => {
    cb(globalStore);
  });
}

export function getStore(cb: getStoreCallback<any>) {
  callbacks.push(cb);
  if (globalStore) {
    cb(globalStore);
  }
}

export function createFormStore<T = any>(initialState: any = {}): Store<FormBaseStore<T>> {
  const store = createStore(formModelStore, initialState, composeWithDevTools(applyMiddleware(thunk)));
  registerStore(store);
  return store;
}

export type thunkGetStateFunc<T> = () => T;
